function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }

  function handleResponse() {
    var res = JSON.parse(this.responseText);

    $('#mini-cart').empty();
    $('.header-tools-cart').empty();
    $('#mini-cart').append($(res['cart-drawer']).html());
    $('.header-tools-cart').append($(res['cart-bubble-icon']).html());
  }

  function cartDrawer(){
    const request = new XMLHttpRequest();
    request.addEventListener('load', handleResponse);
    request.open('GET', '/?sections=cart-drawer,cart-bubble-icon', true);
    request.send();
  }
  $(document).ready(function(){
    $(document).on('click', '.ocu-footer__cta button,.ocu-upsell__cross', function(){
      setTimeout(function(){
        cartDrawer();
        
        $(".custom-overlay").show();
        $('#mini-cart').addClass('active_slide_cart');
      }, 1000)
    });
  });

  $(document).ready(function() { 
    $('body').on('click', '.slide_out_cart_trigger, .custom-overlay', function(event) {
      event.preventDefault();
      $(".custom-overlay").toggle();
      jQuery('#mini-cart').toggleClass('active_slide_cart');
    }); 
    $('body').on('click', '.hc-close', function() {
      $(".custom-overlay").hide();
      jQuery('#mini-cart').removeClass('active_slide_cart');
    });
    $(document).on('click', '.plus-quantity',function(e){
      e.preventDefault();
      var $input = $(this).siblings('.quantity-input');
      var newValue = parseInt($input.val()) + 1;
      $input.val(newValue);
      var $update = {};
      $update[$($input).closest('.item-details').data('id')] = parseInt($($input).val());
      changeQty($update);
      return false;
    });
    $(document).on('click', '.minus-quantity',function(e){
      e.preventDefault();
      var $input = $(this).siblings('.quantity-input');
      var newValue = parseInt($input.val()) - 1;
      $input.val(newValue);
      var $update = {};
      $update[$($input).closest('.item-details').data('id')] = parseInt($($input).val());
      changeQty($update);
      return false;
    });
    $(document).on('click', '.hc-remove',function(e){
      e.preventDefault();
      var $input = $(this).siblings('.quantity-input');
      $input.val('0');
      var $update = {};
      $update[$($input).closest('.item-details').data('id')] = parseInt($($input).val());
      changeQty($update);
      return false;
    });
    $(document).on('change', '.quantity-input', function() {
      var $update = {};
      $update[$(this).closest('.item-details').data('id')] = parseInt($(this).val());
      changeQty($update);
      return false;
    });
    function changeQty($update) {
      $.ajax({
        method: 'POST',
        datatype: 'json',
        data: { updates: $update },
        url: '/cart/update.js',
        success: function(){
          cartDrawer();
        },
        error: function(message){
          if (message['status'] == 200) {
            
          }
        }
      });
    }
  });   